export default function CheckIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_364_15108)">
        <rect width="16" height="16" fill="white" fillOpacity="0.01" />
        <g clipPath="url(#clip1_364_15108)">
          <path
            d="M16 7.99921C16 10.1209 15.1571 12.1558 13.6569 13.6561C12.1566 15.1564 10.1217 15.9992 8 15.9992C5.87827 15.9992 3.84344 15.1564 2.34315 13.6561C0.842855 12.1558 0 10.1209 0 7.99921C0 5.87747 0.842855 3.84264 2.34315 2.34235C3.84344 0.842061 5.87827 -0.000793457 8 -0.000793457C10.1217 -0.000793457 12.1566 0.842061 13.6569 2.34235C15.1571 3.84264 16 5.87747 16 7.99921ZM12.03 4.96921C11.9586 4.89803 11.8735 4.84198 11.7799 4.80442C11.6863 4.76686 11.5861 4.74856 11.4853 4.75062C11.3845 4.75267 11.2851 4.77504 11.1932 4.81637C11.1012 4.85771 11.0185 4.91718 10.95 4.99121L7.477 9.41621L5.384 7.32221C5.24183 7.18973 5.05378 7.1176 4.85948 7.12103C4.66518 7.12446 4.47979 7.20317 4.34238 7.34058C4.20497 7.478 4.12625 7.66338 4.12283 7.85768C4.1194 8.05198 4.19152 8.24003 4.324 8.38221L6.97 11.0292C7.04128 11.1004 7.12616 11.1564 7.21958 11.1941C7.313 11.2317 7.41305 11.2501 7.51375 11.2483C7.61444 11.2464 7.71374 11.2243 7.8057 11.1832C7.89766 11.1421 7.9804 11.083 8.049 11.0092L12.041 6.01921C12.1771 5.87771 12.2523 5.68848 12.2504 5.49216C12.2485 5.29585 12.1698 5.10809 12.031 4.96921H12.03Z"
            fill="#055160"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_364_15108">
          <rect width="16" height="16" fill="white" />
        </clipPath>
        <clipPath id="clip1_364_15108">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
